// src/Views/Admin/AdminTestimonials.js
import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { 
    collection, query, orderBy, onSnapshot, doc, updateDoc, deleteDoc 
} from 'firebase/firestore';
import { Icon } from '@iconify/react';
import './AdminTestimonials.css'; 

const AdminTestimonials = () => {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch ALL reviews (pending, approved, rejected) ordered by newest first
        const q = query(collection(db, 'testimonials'), orderBy('createdAt', 'desc'));
        
        const unsub = onSnapshot(q, (snap) => {
            const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            setReviews(data);
            setLoading(false);
        });
        return () => unsub();
    }, []);

    const updateStatus = async (id, status) => {
        try {
            const ref = doc(db, 'testimonials', id);
            await updateDoc(ref, { status });
        } catch (error) {
            console.error("Error updating status:", error);
            alert("Failed to update status.");
        }
    };

    const deleteReview = async (id) => {
        if(window.confirm("⚠️ Are you sure you want to PERMANENTLY delete this review?")) {
            try {
                await deleteDoc(doc(db, 'testimonials', id));
            } catch (error) {
                console.error("Error deleting:", error);
                alert("Failed to delete.");
            }
        }
    };

    // Helper to format timestamp
    const formatDate = (timestamp) => {
        if (!timestamp) return 'Just now';
        return new Date(timestamp.seconds * 1000).toLocaleDateString() + ' ' + 
               new Date(timestamp.seconds * 1000).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
    };

    return (
        <div className="admin-reviews">
            <div className="admin-reviews__header">
                <h2>Testimonial HQ</h2>
                <div className="admin-reviews__stats">
                    <span className="stat-pill pending">
                        {reviews.filter(r => r.status === 'pending').length} Pending
                    </span>
                    <span className="stat-pill approved">
                        {reviews.filter(r => r.status === 'approved').length} Live
                    </span>
                </div>
            </div>

            {loading ? <p>Loading feed...</p> : (
                <div className="admin-reviews__grid">
                    {reviews.length === 0 && <p className="empty-msg">No reviews found.</p>}
                    
                    {reviews.map(review => (
                        <div key={review.id} className={`review-card status-${review.status || 'pending'}`}>
                            
                            {/* Card Header */}
                            <div className="review-card__top">
                                <div className="user-info">
                                    <span className="user-name">{review.displayName}</span>
                                    <span className="user-date">{formatDate(review.createdAt)}</span>
                                </div>
                                <div className={`status-badge ${review.status || 'pending'}`}>
                                    {review.status || 'pending'}
                                </div>
                            </div>

                            {/* Stars */}
                            <div className="review-card__stars">
                                {[...Array(5)].map((_, i) => (
                                    <Icon 
                                        key={i} 
                                        icon="solar:star-bold" 
                                        style={{ color: i < (review.rating || 5) ? '#fbbf24' : '#334155' }} 
                                    />
                                ))}
                            </div>

                            {/* Text Content */}
                            <div className="review-card__body">
                                "{review.text}"
                            </div>

                            {/* Actions Toolbar */}
                            <div className="review-card__actions">
                                {review.status !== 'approved' && (
                                    <button onClick={() => updateStatus(review.id, 'approved')} className="action-btn approve">
                                        <Icon icon="solar:check-circle-bold" /> Approve
                                    </button>
                                )}
                                
                                {review.status !== 'rejected' && (
                                    <button onClick={() => updateStatus(review.id, 'rejected')} className="action-btn reject">
                                        <Icon icon="solar:close-circle-bold" /> Reject
                                    </button>
                                )}
                                
                                <button onClick={() => deleteReview(review.id)} className="action-btn delete">
                                    <Icon icon="solar:trash-bin-trash-bold" />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AdminTestimonials;